import { useTheme } from "@emotion/react";
import React from "react";
const SmileIcon = () => {
    const { color } = useTheme();
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: color.textMuted, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-smile" },
        React.createElement("circle", { cx: "12", cy: "12", r: "10" }),
        React.createElement("path", { d: "M8 14s1.5 2 4 2 4-2 4-2" }),
        React.createElement("line", { x1: "9", y1: "9", x2: "9.01", y2: "9" }),
        React.createElement("line", { x1: "15", y1: "9", x2: "15.01", y2: "9" })));
};
export default SmileIcon;
//# sourceMappingURL=SmileButton.js.map